import React from "react";
import ReactDom from "react-dom";

type Props = {
  children: JSX.Element;
  isModalOpen: boolean;
};

const Modal: React.FC<Props> = ({ children, isModalOpen }) => {
  if (!isModalOpen) {
    return null;
  }
  return ReactDom.createPortal(
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.7)",
          zIndex: 1000,
        }}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "rgba(237,237,238)",
          padding: "100px",
          borderRadius: "10px",
          zIndex: 1000,
        }}
      >
        {children}{" "}
      </div>
    </>,
    document.getElementById("portal")!
  );
};

export default Modal;
